import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { Anchor } from 'components/designSystem/Link/Anchor'

export const RecommendationTechnologiesMessage: FC = () => {
  return (
    <FormattedMessage
      id="app.we.use.recommendation.technologies"
      defaultMessage="Мы используем <a>Рекомендательные технологии</a>"
      values={{
        a: (chunks) => (
          <Anchor
            href="https://corp.mamba.ru/recommendation"
            target="_blank"
            data-name="recommendation-technologies-action"
          >
            {chunks}
          </Anchor>
        ),
      }}
    />
  )
}
